module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep4_Protein_planet_Mobile.d323f299.jpg";